/* eslint-disable unicorn/consistent-function-scoping */
import type { Wallet } from '../../../schema/frameworks/entry.js';
import type { Currency } from '../../../schema/lib/entry.js';
import { createBrandedData } from '../../../schema/type-utils/entry.js';
import { type IWalletService, NotImplementedError, WalletEntity } from '../../domain/entry.js';

/**
 * Wallet service to handle different types of wallets.
 *
 * @returns Wallet service to retrieve data
 */
export function walletService(): IWalletService {
  const getWalletAsync: IWalletService['getWalletAsync'] = (walletId: Wallet['id']) => {
    if (walletId !== 'WALLET_ID_PLAYER') {
      throw new NotImplementedError(`Wallet id: ${walletId} not implemented yes`);
    }

    return Promise.resolve(
      new WalletEntity({
        id: 'WALLET_ID_PLAYER',
        type: 'WALLET_PLAYER',
        label: 'Min spelkassa',
        meta: {
          balance: createBrandedData<Currency>(1337),
        },
      })
    );
  };

  return {
    getWalletAsync,
  };
}
